// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import { CSVLink } from 'react-csv';

// UI
import { Button } from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import { mdiDownload, mdiPrinter, mdiTableArrowUp } from '@mdi/js';

type Props = {
  ordersDispatch: any;
  data: object[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.ordersDispatch({ ...props.filtersValues, size: 10000 });
  };
  const flattData = (data: any) => {
    const newData = data.map(el => {
      let variantName = el.productName;
      if (el.featureValues) {
        for (let i = 0; i <= 2 && el.featureValues[i]; i++) {
          variantName = variantName.concat(
            ' - ',
            el.featureValues[i].featureName,
            ' : ',
            el.featureValues[i].valueName
          );
        }
      }

      if (el.sellerName || el.providerName) {
        const sellerName = el.sellerName ?? el.providerName;
        variantName = variantName.concat(' ( ', sellerName, ' )');
      }

      return {
        variantId: el.variantId,
        productName: variantName,
        serialNumber: el.serialNumber,
      };
    });
    return newData;
  };

  return (
    <>
      {props.data?.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="parcelVariants.csv"
          style={{
            textDecoration: 'none',
          }}
        >
          <Button variant="contained" color="primary" size="large" endIcon={<Icon path={mdiDownload} size={1} />}>
            {' '}
            دانلود CSV آیتم های انبار
          </Button>
        </CSVLink>
      ) : (
        <Button
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV آیتم های انبار
        </Button>
      )}
    </>
  );
}

export default CSV;
